import { render, staticRenderFns } from "./DevResolveMenu.vue?vue&type=template&id=36d9d1bf&scoped=true&"
import script from "./DevResolveMenu.vue?vue&type=script&lang=js&"
export * from "./DevResolveMenu.vue?vue&type=script&lang=js&"
import style0 from "./DevResolveMenu.vue?vue&type=style&index=0&id=36d9d1bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d1bf",
  null
  
)

export default component.exports